import * as React from "react";
import { Icon } from "sb-resp-ui";

const baseClass = "rj-yourbet__remove";

export class Remove extends React.Component<{
    modifier?: string
    datauat?: string
    icon?: string
    handler: (e: React.MouseEvent<HTMLElement>) => void
}, {}> {
    render() {

        const { modifier, datauat, icon, handler} = this.props;
        const cls = `${baseClass}` + (modifier ?  ` ${baseClass}--${modifier}` : "");

        return (
            <button type="button" className={cls} onClick={handler}>
                <Icon i={icon} data-uat={datauat} />
            </button>
        );
    }
}